<template>
    <div class="NameSystemMemoView">
        <div class="top-section-wrapper">
            <div class="progress-bar-wrapper">
                <div class="progress-bar" :style="{ width: progressBarPercentageWidth }" />
            </div>
            <div class="exit-button-wrapper" @click="$router.go(-1)">Exit</div>
        </div>

        <carousel ref="carousel" :per-page="1" :pagination-enabled="false">
            <slide v-for="item in step.data" :key="item[0]" class="slide">
                <div class="slide-top-wrapper">
                    <h3>{{ item[0] }}</h3>
                    <p>{{ item[1] }}</p>
                </div>
                <div class="image-wrapper">
                    <img src="https://picsum.photos/200/200?grayscale" />
                </div>
            </slide>
        </carousel>
        <div class="direction-buttons-wrapper" :class="{ isLastSlide }">
            <button :disabled="!currentPage" @click="goToPreviousSlide">
                <svgicon icon="arrow-left" class="arrow-icon" />
            </button>
            <button v-if="!isLastSlide" :disabled="isLastSlide" @click="goToNextSlide">
                <svgicon icon="arrow-right" class="arrow-icon" />
            </button>
            <button v-else class="start-quiz-button" @click="goToQuizView">Start quiz</button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';

import memoMixin from './memo.mixin';

export default {
    components: {
        Carousel,
        Slide
    },

    mixins: [memoMixin],

    computed: {
        group() {
            return this.system.groups.find(
                group => group.name === this.routeStringToName(this.$route.params.groupName)
            );
        },

        journey() {
            return this.group.journeys.find(
                journey => journey.name === this.routeStringToName(this.$route.params.journeyName)
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.NameSystemMemoView {
    width: 375px;
    height: 809px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 10px;
    .top-section-wrapper {
        .progress-bar-wrapper {
            .progress-bar {
                transition: 0.3s;
                height: 3px;
                background: white;
            }
        }
        .exit-button-wrapper {
            text-align: right;
            margin-top: 10px;
            color: hsla(0, 0%, 100%, 0.5);
        }
    }
    .slide {
        background-color: rgba(0, 0, 0, 0.1);
        min-height: 337px;
        width: 90%;
        display: flex;
        align-items: center;
        flex-direction: column;
        border-radius: 10px;
        .slide-top-wrapper {
            display: flex;
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
            flex-direction: column;
            width: 100%;
            h3 {
                text-align: center;
                font-weight: normal;
                font-size: 18px;
                margin-bottom: 5px;
            }
            p {
                margin: 15px 0;
                font-size: 15px;
                color: hsla(0, 0%, 100%, 0.6);
                text-align: center;
            }
        }
        .image-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
        }
    }
    .direction-buttons-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        transition: 0.5s;
        width: 100%;
        position: relative;
        button {
            width: 35px;
            height: 35px;
            margin: 10px;
            background: inherit;
            border: none;
            outline: none;
            cursor: pointer;
            &:disabled {
                opacity: 0.5;
            }
            .arrow-icon {
                width: 100%;
                height: 100%;
                fill: white;
            }
        }

        .start-quiz-button {
            min-width: 100px;
            background-color: white;
            border-radius: 5px;
            font-size: 16px;
            line-height: 35px;
            margin: 0;
        }

        &.isLastSlide {
            width: calc(50% + 50px);
            height: 55px;

            button:first-of-type {
                position: absolute;
                right: 150px;
            }
            .start-quiz-button {
                position: absolute;
                right: 0;
            }
        }
    }
}
</style>
